import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';

import { emissionValueWithDecimals } from '../../../../../../../../../../../shared/helpers/emission-value-with-decimals';
import styles from '../CalculationDetails.module.css';

export type IChartData = {
  value: number;
  color: string;
  title: string;
};

type EmissionsBreakdownChartProps = {
  data: IChartData[];
};

const EmissionsBreakdownChart = ({ data }: EmissionsBreakdownChartProps): JSX.Element => {
  const valuesSum = data.reduce((a, b) => {
    return a + b.value;
  }, 0);

  const percentages = data.map((item) => {
    return (item.value / valuesSum) * 100;
  });

  const getBarWidth = (percentage: number): string => {
    return `${Math.max(percentage, 3)}%`;
  };

  return (
    <div className='flex h-10 w-full h-2rem'>
      {percentages.map((percentage, index) => {
        if (!percentage) {
          return null;
        }

        return (
          <div
            className='flex border-white border-1'
            key={index}
            style={{ width: getBarWidth(percentage) }}
          >
            <Tooltip
              target={`.tooltip-target-${index}`}
              className='opacity-100'
              position='top'
              pt={{
                text: { className: 'opacity-100 z-1 font-medium px-3 text-lg' },
              }}
            />
            <div
              className={classNames(
                `tooltip-target-${index}`,
                'flex text-white text-sm font-medium justify-content-center align-items-center w-full',
                styles['chart-bar'],
                styles[`${data[index].color}-color-box`],
                {
                  'border-round-left-lg': index === 0,
                  'border-round-right-lg': index === percentages.length - 1,
                },
              )}
              data-pr-tooltip={`${emissionValueWithDecimals(percentage, 2)}%`}
            />
          </div>
        );
      })}
    </div>
  );
};

export default EmissionsBreakdownChart;
